<script lang="ts">
    import { createEventDispatcher } from "svelte";
    import {
        Button,
        Col,
        Form,
        FormGroup,
        Input,
        Label,
        Modal,
        ModalBody,
        ModalFooter,
        ModalHeader,
        Row,
    } from "sveltestrap";

    import { paramsService, subtypesDiligencesService } from "../services";
    import type { Param } from "../Model/Param";
    import type { SubtypesDiligences } from "../Model/SubtypesDiligences";

    const dispatch = createEventDispatcher();

    let size = "xs";
    let subtype: SubtypesDiligences;
    let showButton = false;

    export let open;
    export let type;
    export let editSubtype: SubtypesDiligences;
    export let removeButton;

    open = false;
    type = null;
    removeButton = false;

    $: load(editSubtype);

    const toggle = () => {
        size = 'xs';
        open = !open;
    };

    async function save() {
        let response = await subtypesDiligencesService.saveSubType(subtype);   

        if (response) {
            dispatch("addSubtype", subtype);
            editSubtype = null;
            open = false;
        }
    }

    async function remove() {
        if (!confirm("¿Esta seguro de querer eliminar el parámetro?")) return;

        let response = await subtypesDiligencesService.removeSubType(subtype);

        if (response) {
            dispatch("removeSubtype", subtype);
            editSubtype = null;
            open = false;
        }
    }

    function load(editSubtype) {
        subtype = editSubtype;
        showButton = removeButton;
    }
</script>

<Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>Editar parámetro</ModalHeader>
    <ModalBody>
        {#if subtype}
            <Form id="info">
                <Row>
                    <Col xs="12">
                        <FormGroup>
                            <Label for="exampleEmail">Nombre</Label>
                            <Input type="text" bind:value={subtype.subTypeDiligence} />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        {/if}
    </ModalBody>
    <ModalFooter>
        {#if removeButton && showButton}
            <Button color="danger" on:click={remove}>Eliminar</Button>
        {/if}
        <Button color="primary" on:click={save}>Guardar</Button>
    </ModalFooter>
</Modal>